<template>
  <div>
    <table class="table table-sm">
      <thead></thead>
      <tbody>
        <tr>
          <td>RESIDENTE</td>
          <td>
            <strong>{{ stock_sale.resident_name }}</strong>
          </td>
        </tr>
        <tr>
          <td>MEDICAMENTO</td>
          <td>
            <strong>{{ stock_sale.medicine_name }}</strong>
          </td>
        </tr>
        <tr>
          <td>VALOR DA VENDA</td>
          <td>
            <strong>{{ formatReal(String(stock_sale.value)) }}</strong>
          </td>
        </tr>
        <tr>
          <td>RESPONSÁVEL</td>
          <td>
            <strong>{{
              professionalClassCouncilValue({
                id: stock_sale.user_professional_class_council_id,
                name: stock_sale.user_name,
                profile: stock_sale.user_profile_name,
                office: stock_sale.user_office,
                cpf: stock_sale.user_cpf,
                value: stock_sale.user_professional_class_council_value,
              })
            }}</strong>
          </td>
        </tr>
        <tr>
          <td>GRUPO</td>
          <td>
            <strong>{{ stock_sale.stock_group_name }}</strong>
          </td>
        </tr>
        <tr>
          <td>LOTE</td>
          <td>
            <strong>{{ stock_sale.lot }}</strong>
          </td>
        </tr>
        <tr>
          <td>{{ stock_sale.stock_item_unit_of_measurement_abbreviation }}</td>
          <td>
            <strong>
              {{ stock_sale.amount }}
              {{ stock_sale.stock_item_unit_of_measurement_abbreviation }}
            </strong>
          </td>
        </tr>
        <tr>
          <td>DATA DE VENCIMENTO</td>
          <td>
            <strong>{{ moment(stock_sale.due_date).format("MM/YYYY") }}</strong>
          </td>
        </tr>
        <tr v-if="stock_sale.description">
          <td>DESCRIÇÃO</td>
          <td>
            <strong>{{ stock_sale.description }}</strong>
          </td>
        </tr>
        <tr>
          <td>DATA DA VENDA</td>
          <td>
            <strong>{{
              moment(stock_sale.created_at).format("DD/MM/YYYY HH:mm:ss")
            }}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from "moment";

import {
  formatReal,
  professionalClassCouncilValue,
} from "../../../../../lib/format";

export default {
  name: "Details",

  props: {
    stock_sale: Object,
  },

  created() {},

  methods: {
    moment,
    professionalClassCouncilValue,
    formatReal,
  },
};
</script>
